import { Component } from '@angular/core';

@Component({
	selector: 'pms-basic-print-template',
	templateUrl: './basic-print-template.component.html',
	styles: [],
	standalone: false,
})
export class BasicPrintTemplateComponent {

	constructor() {
	}

}
